import { schema } from "normalizr";

export const requiredAttachment = new schema.Entity("requiredAttachment");
export const requiredAttachmentList = [requiredAttachment];
